module.exports = __webpack_public_path__ + "static/media/person-booth.cde098ec.svg";